module.exports = __webpack_public_path__ + "img/btn-edit-name.6b363cee.png";